export const tableProps = {

    perPageValues: [10, 20, 30, 50, 100],

    sortIcon: {
        base: 'fa',
        up: 'fa-sort-amount-asc',
        down: 'fa-sort-amount-desc',
        is: 'fa-sort'
    },

    tableTexts: {
        count: "Mostrando del {from} al {to} de {count} registros|{count} registros|Único registro",
        first: 'Primero',
        last: 'Último',
        filter: "Filtrar:",
        filterPlaceholder: "Ingrese...",
        limit: "Registros:",
        page: "Página:",
        noResults: "No hay registros.",
        filterBy: "Filtrando por {column}",
        loading: 'Cargando...',
        defaultOption: 'Select {column}',
        columns: 'Columns'
    }

}